import { BoardViewType } from "app/types";
import React from "react";
import Kanban from "../containers/Kanban";
import List from "../containers/List";

export default function Tickets({ type }: { type: BoardViewType }) {
  return (
    <div
      className="w-full min-w-0 flex-1 overflow-y-auto overflow-x-auto space-y-[16px]"
      style={{
        scrollbarColor: "#E5E7EB ",
        msOverflowStyle: "none",
      }}
    >
      {type === BoardViewType.KANBAN ? (
        <Kanban />
      ) : (
        <div className="flex h-[calc(100vh-162px)] w-full min-w-0">
          <List />
        </div>
      )}
    </div>
  );
}
